// 서버에 아예 연결이 안 될 때를 알린다 — 프레임워크 없이. React 훅은 react.js.
//
// **`fetch` 가 거부할 때만** 안 닿은 것이다. 서버가 낸 에러 응답(503 등)은 「응답」이고, 그건 그 화면이
// 자기 문장으로 보여 줄 일이다 — 여기서 전역 안내로 바꿔치기하면 서버가 살아 있는데 왜 죽은 것처럼
// 보이는지 아무도 모른다(sw.js 가 연결 실패와 에러 응답을 가르는 것과 같은 결).
// (b3x-in src/lib/connectivity.ts 를 올린 것이다.)

export const REACHABLE_CHECK_MS = 15_000;

/**
 * @param {string} url 서비스의 건강 확인 주소(예 "/api/health")
 * @param {typeof fetch} [fetchFn]
 * @returns {Promise<boolean>} 응답이 오면(상태와 무관) 참, 연결 자체가 실패하면 거짓
 */
export function probeReachable(url, fetchFn = globalThis.fetch) {
  return Promise.resolve()
    .then(() => fetchFn(url, { cache: "no-store" }))
    .then(
      () => true,
      () => false,
    );
}

/**
 * 바로 한 번, 그 뒤 간격마다, 그리고 브라우저가 「온라인」을 알릴 때 확인한다.
 * @param {string} url
 * @param {(reachable: boolean) => void} onResult
 * @param {{ intervalMs?: number, win?: any, fetchFn?: typeof fetch }} [opts]
 * @returns {() => void} 멈추기
 */
export function watchReachable(url, onResult, { intervalMs = REACHABLE_CHECK_MS, win = globalThis, fetchFn } = {}) {
  let alive = true;
  const check = () => probeReachable(url, fetchFn).then((ok) => alive && onResult(ok));
  check();
  const id = win.setInterval(check, intervalMs);
  win.addEventListener("online", check);
  return () => {
    alive = false;
    win.clearInterval(id);
    win.removeEventListener("online", check);
  };
}
